import { SelectOption } from '../blocks/Option/Option';
import { SELECT_MODES } from './constants';
import { ReactElement, ReactNode } from 'react';
import { Modes, MultipleOnChange, SingleOnChange } from './types';
import { OptionGroupProps } from '../Select';

export const isOptionGroup = <T extends SelectOption, K extends OptionGroupProps>(
  option: T | K
): option is K => {
  return !!option.isOptionGroup;
};

export const isSingleOnChange = <Option extends SelectOption>(
  mode: Modes,
  onChange: SingleOnChange<Option> | MultipleOnChange<Option>
): onChange is SingleOnChange<Option> => mode === SELECT_MODES.SINGLE;

export const isReactElement = (prop: ReactNode): prop is ReactElement[] | ReactElement => {
  if (Array.isArray(prop)) {
    return prop[0]!.hasOwnProperty('$$typeof');
  }

  return !!prop?.hasOwnProperty('$$typeof');
};

const toArray = <T>(value: T): T[] => {
  if (Array.isArray(value)) {
    return value;
  }

  return [value];
};

export const getParsedSelectOptions = <Option extends SelectOption>(
  data: ReactNode
): (Option | OptionGroupProps)[] => {
  if (isReactElement(data)) {
    const parsedOptions: (Option | OptionGroupProps)[] = [];

    toArray(data).forEach((child: any) => {
      if (child.props.value === undefined) {
        parsedOptions.push({
          isOptionGroup: true,
          label: child.props.label,
          className: child.props.className,
        } as OptionGroupProps);

        getParsedSelectOptions(child.props.children).forEach((innerChild) =>
          parsedOptions.push(innerChild as Option)
        );
      } else {
        parsedOptions.push({
          ...child.props,
          label: child.props.children,
        } as Option);
      }
    });

    return parsedOptions;
  }

  return [];
};
